import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@env/env';

if (environment.production) {
  console.log('Ambiente atual: Produção');
} else {
  console.log('Ambiente atual: Desenvolvimento');
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
